import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { LessonUsageResult } from '../../../hooks/useLessonUsage';
import styles from './UsedInLessonsTooltipContent.module.scss';

type UsedInLessonTooltipProps = {
  /** Höchstens drei Zuordnungen als Beispiel. */
  lessons: LessonUsageResult['lessons'];
  /** Zahl aller Zuordnungen; sind es mehr als die gezeigten, steht „...“ darunter. */
  lessonsCount: number;
  usedInText: ReactNode;
};

export const UsedInLessonsTooltipContent: FC<UsedInLessonTooltipProps> = ({ lessons, lessonsCount, usedInText }) => {
  const { t } = useTranslation();
  return (
    <div className={styles['used-in-lessons']}>
      <div className={styles.title}>{usedInText}</div>
      <ul className={styles.lessons}>
        {lessons.map((lesson) => {
          return (
            <li key={lesson.uuid} className={styles.lesson}>
              {lesson.subjectName}, {t('classes.title', { count: lesson.classShortNames.length })}:{' '}
              {lesson.classShortNames.join(', ')}
              <ul className={styles.versions}>
                {lesson.onlyInTimetableVersion || lesson.onlyInTeachingBlockVersion ? (
                  <li>{t('deputate.lesson')}</li>
                ) : (
                  <>
                    {lesson.versions.map((v) => {
                      return (
                        <li key={v.uuid}>
                          {v.timetableName}, {t('timetableVersion.title', { count: 1 })} {v.version}
                        </li>
                      );
                    })}
                    {lesson.versionsCount > lesson.versions.length && <li>...</li>}
                  </>
                )}
              </ul>
            </li>
          );
        })}
      </ul>
      {lessonsCount > lessons.length && <div className={styles.more}>...</div>}
    </div>
  );
};
